import React, { useState } from 'react';
import ButtonBase from '@mui/material/ButtonBase';
import styled from 'styled-components';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import { StaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';
import { Dialog } from '@mui/material';
import dayjs, { type Dayjs } from 'dayjs';
import CalendarIcon from '../../icons/CalendarIcon';
import ClockIcon from '../../icons/ClockIcon';

interface Props {
  type: string;
}

interface CustomButtonBaseI {
  pickerIsOpen: boolean;
}

export default function DateTimeSelector({ type }: Props): JSX.Element {
  const today = Date.now();
  const [selectedDate, setSelectedDate] = useState<Date | null | Dayjs>(dayjs(today));
  const [pickerIsOpen, setPickerIsOpen] = useState(false);
  return (
    <>
      <CustomButtonBase
        pickerIsOpen={pickerIsOpen}
        onClick={() => {
          setPickerIsOpen(true);
        }}
      >
        {type === 'date' ? <DateText>2023-03-29</DateText> : <DateText>14:00</DateText>}
        {type === 'date' ? <CalendarIcon /> : <ClockIcon />}
      </CustomButtonBase>
      <Dialog
        open={pickerIsOpen}
        onClose={() => {
          setPickerIsOpen(false);
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {type === 'date' ? (
            <StaticDatePicker
              defaultValue={dayjs(selectedDate)}
              value={selectedDate}
              onChange={(newValue) => {
                setSelectedDate(newValue);
              }}
              onClose={() => {
                setPickerIsOpen(false);
              }}
              disablePast
              localeText={{
                cancelButtonLabel: 'Cancelar',
                toolbarTitle: 'Selecciona la fecha',
              }}
            />
          ) : (
            <StaticTimePicker
              defaultValue={dayjs(selectedDate)}
              value={selectedDate}
              onChange={(newValue) => {
                setSelectedDate(newValue);
              }}
              onClose={() => {
                setPickerIsOpen(false);
              }}
              disablePast
              localeText={{
                cancelButtonLabel: 'Cancelar',
                toolbarTitle: 'Selecciona la hora',
              }}
            />
          )}
        </LocalizationProvider>
      </Dialog>
    </>
  );
}

const CustomButtonBase = styled(ButtonBase)<CustomButtonBaseI>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  border: 1px solid ${(props) => (!props.pickerIsOpen ? '#f0f6fa' : props.theme.colors.primary)};
  border-radius: 5px;
  height: 40px;
  width: 160px;
  padding-left: 13px;
  padding-right: 13px;
`;

const DateText = styled.p`
  font-family: ${(props) => props.theme.fonts.regular};
  color: ${(props) => props.theme.colors.darkGray};
  font-size: 13px;
  flex: 1;
  text-align: left;
`;
